module.exports = __webpack_public_path__ + "static/media/Public_47.9ac152b1.jpg";